import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { services } from "../mock/mock";
import { serviceIcons } from "../components/icons";

const ServiceDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const service = services.find((s) => s.slug === slug);
  const others = services.filter((s) => s.slug !== slug);

  if (!service) {
    return (
      <div className="max-w-[900px] mx-auto px-5 py-24 text-center">
        <h1 className="font-heading text-3xl font-semibold">Service not found</h1>
        <Link to="/" className="text-[#D80000] mt-4 inline-block">Back to home</Link>
      </div>
    );
  }

  const Icon = serviceIcons[service.icon];

  return (
    <div className="bg-white">
      <section className="bg-[#141414] py-16">
        <div className="max-w-[1140px] mx-auto px-5">
          <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-5">
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
          <div className="flex items-center gap-5">
            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D80000]">
              {Icon && <Icon className="w-8 h-8 text-white" strokeWidth={1.8} />}
            </span>
            <div>
              <p className="text-[#D80000] font-heading font-semibold tracking-widest text-sm">OUR SERVICES</p>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-white">{service.title}</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-[820px] mx-auto px-5">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-[#1a1a1a] leading-snug">{service.tagline}</h2>
          <p className="text-[#1a1a1a]/80 leading-8 mt-5 text-lg">{service.description}</p>
          <p className="text-[#1a1a1a]/80 leading-8 mt-4">
            As part of our end-to-end approach, our {service.title.toLowerCase()} stage is fully
            integrated with the rest of the workflow &mdash; so your project moves
            seamlessly from one step to the next with a single point of
            accountability.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-9 bg-[#D80000] text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#b00000]">
            Discuss Your Project <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      <section className="bg-[#f7f7f8] py-16">
        <div className="max-w-[1140px] mx-auto px-5">
          <h2 className="font-heading text-2xl font-semibold text-[#1a1a1a] mb-8">Explore Our Other Services</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {others.map((s) => {
              const OtherIcon = serviceIcons[s.icon];
              return (
                <Link key={s.slug} to={`/services/${s.slug}`} className="group bg-white rounded-lg p-6 text-center shadow-sm hover:shadow-xl transition-shadow flex flex-col items-center">
                  <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#f3f4f6] group-hover:bg-[#D80000] transition-colors">
                    {OtherIcon && <OtherIcon className="w-6 h-6 text-[#D80000] group-hover:text-white transition-colors" strokeWidth={1.8} />}
                  </span>
                  <p className="font-heading font-semibold text-[#1a1a1a] group-hover:text-[#D80000] text-sm mt-4">{s.title}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
